import * as React from 'react';

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const SvgAlertOutline = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#3A3247",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M17.333 17.334h-2.666v-6.667h2.666zm0 4h-2.666v-2.667h2.666zM16 24c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.589 8 8-3.59 8-8 8m0-18.667C10.11 5.333 5.334 10.109 5.334 16c0 5.89 4.776 10.666 10.666 10.666S26.667 21.89 26.667 16 21.89 5.334 16 5.334"
})));

export { SvgAlertOutline as ReactComponent };
//# sourceMappingURL=AlertOutline.svg.js.map
